/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/select/custom-elements';

import { defineCustomElement as defineOsdsSelect } from '@ovhcloud/ods-stencil/components/select/custom-elements/osds-select.js';
import { defineCustomElement as defineOsdsSelectGroup } from '@ovhcloud/ods-stencil/components/select/custom-elements/osds-select-group.js';
import { defineCustomElement as defineOsdsSelectOption } from '@ovhcloud/ods-stencil/components/select/custom-elements/osds-select-option.js';


export const OsdsSelect = /*@__PURE__*/ defineContainer<JSX.OsdsSelect>('osds-select', defineOsdsSelect, [
  'opened',
  'ariaLabel',
  'ariaLabelledby',
  'color',
  'defaultValue',
  'disabled',
  'flex',
  'required',
  'size',
  'value',
  'odsValueChange',
  'odsFocus',
  'odsBlur'
]);


export const OsdsSelectGroup = /*@__PURE__*/ defineContainer<JSX.OsdsSelectGroup>('osds-select-group', defineOsdsSelectGroup);


export const OsdsSelectOption = /*@__PURE__*/ defineContainer<JSX.OsdsSelectOption>('osds-select-option', defineOsdsSelectOption, [
  'selected',
  'value',
  'odsSelectOptionClick'
]);

